import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./index.component.css']
})
export class IndexComponent {
}
